import classNames from 'classnames';
import { useFramework } from '../../hooks';
import './layer-loading.less';

interface LayerLoadingProps {
    scale?: number;
    blur?: number;
    isTextLayer?: boolean;
    hideIcon?: boolean;
    borderRadius?: number;
}

export const LayerLoading = ({
    scale = 1,
    blur = 10,
    isTextLayer = false,
    hideIcon = false,
    borderRadius,
}: LayerLoadingProps) => {
    const framework = useFramework();
    const isEdgelessMode = framework.service.edgelessCanvas.isEdgelessMode;

    return (
        <div
            style={
                {
                    '--backdrop-filter-blur': `${Math.max(blur, 8)}px`,
                    borderRadius,
                } as React.CSSProperties
            }
            className={classNames('layer-loading-wrap', {
                'edgeless-mode': isEdgelessMode && !isTextLayer,
            })}
        >
            {!hideIcon && (
                <div className="layer-loading" style={{ transform: `scale(${scale})` }}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            )}
        </div>
    );
};
